'use client'

import type { CSSProperties, ReactNode } from 'react'
import { useAccent, type AccentVar } from './AccentContext'

export function DzPanel({
  children,
  icon,
  accent,
  className,
  style
}: {
  children?: ReactNode
  icon?: ReactNode
  accent?: AccentVar
  className?: string
  style?: CSSProperties
}) {
  const { v } = useAccent()
  const a = accent || v
  return (
    <div className={className ? `st-dz-panel ${className}` : 'st-dz-panel'} style={style}>
      <div className="icon" style={{ background: `var(${a})` }}>
        {icon || (
          <svg
            className="st-dz-arrow"
            width="44"
            height="44"
            viewBox="0 0 40 40"
            fill="none"
            stroke="#0a0a0a"
            strokeWidth="3.5"
            strokeLinecap="square">
            <path d="M8 26 L20 10 L32 26" />
            <path d="M20 10 L20 32" />
            <path d="M6 34 L34 34" />
          </svg>
        )}
      </div>
      {children}
    </div>
  )
}
